import { z } from 'zod'

export const pendingChangesSchema = z.object({
  txn_update: z.string().nullable(),
  rule_upsert: z.string().nullable(),
  rule_delete: z.string().nullable(),
  ingestion_update: z.string().nullable(),
  source_delete: z.string().nullable(),
  config_update: z.string().nullable(),
  pricing_update: z.string().nullable(),
  mapping_upsert: z.string().nullable(),
  mapping_delete: z.string().nullable(),
  spam_token_create: z.string().nullable(),
  spam_token_delete: z.string().nullable(),
  spam_token_toggle_ingestion: z.string().nullable(),
  pricing_refresh_request: z.string().nullable(),
})

export type PendingChanges = z.infer<typeof pendingChangesSchema>

export const pendingChangesChildSchema = z.object({
  slug: z.string(),
  last_successful_valid_dag_run_start_time: z.string().nullable(),
  pending_changes: pendingChangesSchema,
})

export type PendingChangesChild = z.infer<typeof pendingChangesChildSchema>

export const pendingChangesResponseSchema = z.object({
  slug: z.string(),
  last_successful_valid_dag_run_start_time: z.string().nullable(),
  average_dag_run_time_seconds: z.number().nullable(),
  pending_changes: pendingChangesSchema,
  children: z.array(pendingChangesChildSchema),
})

export type PendingChangesResponse = z.infer<typeof pendingChangesResponseSchema>
